import { ContentCopy, Delete, HourglassEmpty } from "@mui/icons-material";
import React, { memo, useState } from "react";
import { Handle } from "react-flow-renderer";
import { useNodeStorage } from "../../../stores/useNodeStorage";

// Mostra o tempo do jeito que foi configurado: 1440 minutos vira "1 dia".
const tempoLegivel = (minutos) => {
  const m = Number(minutos) || 0;
  if (m <= 0) return "";
  if (m % 1440 === 0) {
    const d = m / 1440;
    return `${d} ${d === 1 ? "dia" : "dias"}`;
  }
  if (m % 60 === 0) {
    const h = m / 60;
    return `${h} ${h === 1 ? "hora" : "horas"}`;
  }
  if (m < 1) {
    const s = Math.round(m * 60);
    return `${s} ${s === 1 ? "segundo" : "segundos"}`;
  }
  return `${m} ${m === 1 ? "minuto" : "minutos"}`;
};

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();
  const [isHovered, setIsHovered] = useState(false);

  const d = data || {};
  const mins = Number(d.noAnswerMinutes) || 0;

  const chip = (text) => (
    <span
      key={text}
      style={{
        fontSize: "11px",
        background: "#eef2ff",
        color: "#4338ca",
        borderRadius: "999px",
        padding: "2px 8px",
        marginRight: 4,
        marginTop: 4,
        display: "inline-block",
      }}
    >
      {text}
    </span>
  );

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        backgroundColor: "#ffffff",
        padding: "20px",
        borderRadius: "16px",
        minWidth: "260px",
        maxWidth: "260px",
        width: "260px",
        boxSizing: "border-box",
        position: "relative",
        fontFamily: "'Inter', sans-serif",
        border: "2px solid #e5e7eb",
        boxShadow: isHovered
          ? "0 12px 32px rgba(0,0,0,0.12)"
          : "0 4px 16px rgba(0,0,0,0.06)",
        transition: "all 0.2s cubic-bezier(0.4,0,0.2,1)",
        transform: isHovered ? "translateY(-2px)" : "translateY(0px)",
        pointerEvents: "auto",
        userSelect: "none",
      }}
    >
      <Handle
        type="target"
        position="left"
        style={{
          background: "linear-gradient(135deg, #f59e0b, #d97706)",
          width: "16px",
          height: "16px",
          top: "24px",
          left: "-10px",
          cursor: "pointer",
          border: "3px solid #ffffff",
        }}
        isConnectable={isConnectable}
      />

      {/* Botões */}
      <div
        style={{
          position: "absolute",
          top: "10px",
          right: "10px",
          display: "flex",
          gap: "4px",
          zIndex: 10,
          opacity: isHovered ? 1 : 0,
          transition: "opacity 0.2s",
        }}
      >
        <div
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("duplicate");
          }}
          style={{
            width: "28px",
            height: "28px",
            cursor: "pointer",
            borderRadius: "8px",
            backgroundColor: "#f3f4f6",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ContentCopy sx={{ width: "14px", height: "14px", color: "#6b7280" }} />
        </div>
        <div
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("delete");
          }}
          style={{
            width: "28px",
            height: "28px",
            cursor: "pointer",
            borderRadius: "8px",
            backgroundColor: "#fee2e2",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Delete sx={{ width: "14px", height: "14px", color: "#dc2626" }} />
        </div>
      </div>

      {/* Cabeçalho */}
      <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
        <div
          style={{
            width: "34px",
            height: "34px",
            borderRadius: "10px",
            background: "linear-gradient(135deg, #f59e0b, #d97706)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginRight: "10px",
          }}
        >
          <HourglassEmpty sx={{ color: "#fff", width: "18px", height: "18px" }} />
        </div>
        <div style={{ fontWeight: 700, fontSize: "15px", color: "#111827" }}>
          Verifica se segue
        </div>
      </div>

      {d.message ? (
        <div
          style={{
            fontSize: "12px",
            color: "#4b5563",
            background: "#f9fafb",
            borderRadius: "8px",
            padding: "8px",
            marginBottom: "6px",
            maxHeight: "60px",
            overflow: "hidden",
          }}
        >
          {d.message}
        </div>
      ) : null}

      <div style={{ marginBottom: "6px" }}>
        {chip(`{{${d.answerKey || "resposta"}}}`)}
        {d.bufferEnabled ? chip(`buffer ${d.bufferSeconds || 30}s`) : null}
        {d.reactEnabled ? chip(`reage ${d.reactEmoji || "✅"}`) : null}
        {d.quoteEnabled ? chip("cita msg") : null}
      </div>

      {/* Legendas das saídas */}
      <div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12, color: "#6b7280" }}>
        <span
          style={{
            width: 10,
            height: 10,
            borderRadius: "50%",
            background: "linear-gradient(135deg, #10b981, #059669)",
            display: "inline-block",
          }}
        />
        Ja segue
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 4, fontSize: 12, color: "#6b7280" }}>
        <span
          style={{
            width: 10,
            height: 10,
            borderRadius: "50%",
            background: "linear-gradient(135deg, #9ca3af, #6b7280)",
            display: "inline-block",
          }}
        />
        "Ainda nao segue"
      </div>

      {/* Saída: respondeu */}
      <Handle
        type="source"
        position="right"
        id="sim"
        style={{
          background: "linear-gradient(135deg, #10b981, #059669)",
          border: "2px solid #ffffff",
          width: "12px",
          height: "12px",
          right: "-6px",
          top: "72%",
          bottom: "auto",
          transform: "translateY(-50%)",
        }}
        isConnectable={isConnectable}
      />

      {/* Saída: não respondeu */}
      <Handle
        type="source"
        position="right"
        id="nao"
        style={{
          background: "linear-gradient(135deg, #9ca3af, #6b7280)",
          border: "2px solid #ffffff",
          width: "12px",
          height: "12px",
          right: "-6px",
          top: "88%",
          bottom: "auto",
          transform: "translateY(-50%)",
        }}
        isConnectable={isConnectable}
      />
    </div>
  );
});
